import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { formatCNPJ, showNotification } from 'helpers'

let EmpresasCertificadoForm = props => {
    const { handleSubmit, pristine, submitting } = props

    const maskField = event => {
        if (event.currentTarget.value.length >= 14)
            event.currentTarget.value = formatCNPJ(event.currentTarget.value)
    }
    const toggleInputFile = event => {
        event.preventDefault()
        document.getElementById('pfx').click()
    }

    const FileInput = ({ input, resetKey }) => {
        const { value, ...inputProps } = input    
        const handleChange = (e) => {
            const file = e.currentTarget.files[0]
            if (file.size > 10000) {
                e.preventDefault()
                showNotification('Arquivo inválido!', 'alert-warning', 3000)
            } else {
                document.getElementById('pfxfake').value = file.name
                input.onChange(e.target.files[0]) 
            }
        }    
        return (
            <input {...inputProps} key={resetKey} style={{ display: 'none' }} id="pfx" accept=".pfx,.p12" type="file" onChange={handleChange} onBlur={() => {}} />
        )
    }

    return (
        <form onSubmit={handleSubmit} className="col col-sm-6 offset-sm-3">

            <div className="form-group">
                <label htmlFor="cnpj">CNPJ</label>
                <Field className="form-control" id="cnpj" name="cnpj" placeholder="CNPJ" onKeyUp={event => maskField(event)} component="input" type="text" />
            </div>

            <label htmlFor="pfxfake">PFX</label>
            <div className="input-group">
                <Field component="input" type="text" name="pfxfake" className="form-control" id="pfxfake" disabled placeholder="Escolher arquivo..." />
                <div className="input-group-append">
                    <span style={{ cursor: 'pointer' }} className="input-group-text" id="basic-addon2" onClick={event => toggleInputFile(event)}><i className="fas fa-cloud"></i></span>
                </div>
                <Field component={FileInput} name="pfx" />
            </div>

            <div className="form-group mt-2">
                <label htmlFor="senha">SENHA</label>
                <Field component="input" type="text" name="senha" autoComplete="off" className="form-control" id="senha" placeholder="Informar senha do PFX" />
            </div>

            <button type="submit" disabled={pristine || submitting} className="btn btn-primary">
                {submitting ? <div><i className="fas fa-spinner fa-spin fa-fw"></i> Enviando...</div> : 'Enviar'}
            </button>

        </form>
    )
}

export default reduxForm({ form: 'certificado' })(EmpresasCertificadoForm)